/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".iti-flag[_ngcontent-%COMP%]{position:absolute;transform:translateY(-50%);top:50%;left:12px;display:none}[_nghost-%COMP%]{position:relative;display:block;width:100%}.country-found[_nghost-%COMP%]   .iti-flag[_ngcontent-%COMP%]{display:block}.country-found[_nghost-%COMP%]   input[_ngcontent-%COMP%]{padding-left:40px}input[_ngcontent-%COMP%]{transition:padding-left .3s;line-height:1.2}"];
export { styles as styles };
